import { computed, type ComputedRef } from 'vue';
import type { Experience as ExpCardExperience } from '@experience/exp-card/dist/types/experience';
import type { Experience as ApiExperience } from '@/shared/api/experience/types.gen';
import { isValidMovementType, type TMovementType } from '../types';
import { useMovementTypes } from '../api/useMovementTypes';

interface UseExperienceWithMovementTypeOptions {
  experiences: ComputedRef<ApiExperience[] | undefined>;
}

export function useExperienceWithMovementType({
  experiences,
}: UseExperienceWithMovementTypeOptions): ComputedRef<ExpCardExperience[]> {
  const { movementTypesExpCardLabels } = useMovementTypes();

  return computed<ExpCardExperience[]>(() => {
    if (!experiences.value) {
      return [];
    }

    return experiences.value.map((experience) => ({
      ...experience,
      movement_type:
        experience.movement_type && isValidMovementType(experience.movement_type)
          ? (movementTypesExpCardLabels.value?.[experience.movement_type as TMovementType] as string)
          : '',
      isUnderSanctions: experience.is_under_sanctions ?? false,
    })) as ExpCardExperience[];
  });
}
